// packages/shared-i18n/index.ts
import i18n, {
  LANGUAGE_STORAGE_KEY,
  LANGUAGES,
  getStoredLanguage,
  setStoredLanguage,
  switchAppLanguage,
  syncLanguageFromHost,
} from "./i18n";
import { applyBrandLocale, getBrandDisplayName } from "./applyBrandLocale";

export {
  i18n,
  applyBrandLocale,
  getBrandDisplayName,
  LANGUAGE_STORAGE_KEY,
  LANGUAGES,
  getStoredLanguage,
  setStoredLanguage,
  switchAppLanguage,
  syncLanguageFromHost,
};
export type { LanguageType } from "./i18n";
export { default as LanguageSwitcher } from "./components/LanguageSwitcher";

// 默认导出 i18n 实例
export default i18n;
